var map = {
	"./affiliates-profit-range": [
		8660,
		9,
		104,
		660
	],
	"./affiliates-profit-range.js": [
		8660,
		9,
		104,
		660
	],
	"./benefits-forex-trader-section": [
		120,
		9,
		104,
		120
	],
	"./benefits-forex-trader-section.js": [
		120,
		9,
		104,
		120
	],
	"./broker-selector-section": [
		2360,
		9,
		104,
		979
	],
	"./broker-selector-section.js": [
		2360,
		9,
		104,
		979
	],
	"./contact-form": [
		1360,
		7,
		360
	],
	"./contact-form.js": [
		1360,
		7,
		360
	],
	"./exit-pop-up": [
		5051,
		9,
		104,
		51
	],
	"./exit-pop-up.js": [
		5051,
		9,
		104,
		51
	],
	"./faq": [
		3736,
		7,
		736
	],
	"./faq.js": [
		3736,
		7,
		736
	],
	"./globe-section": [
		9556,
		9,
		104,
		556
	],
	"./globe-section.js": [
		9556,
		9,
		104,
		556
	],
	"./header-navigation": [
		9456,
		9,
		104,
		456
	],
	"./header-navigation.js": [
		9456,
		9,
		104,
		456
	],
	"./modified-lp-trustpilot": [
		4480,
		9,
		104,
		480
	],
	"./modified-lp-trustpilot.js": [
		4480,
		9,
		104,
		480
	],
	"./odometer": [
		1536,
		9,
		104,
		536
	],
	"./odometer.js": [
		1536,
		9,
		104,
		536
	],
	"./pricing-slider": [
		9784,
		9,
		104,
		784
	],
	"./pricing-slider.js": [
		9784,
		9,
		104,
		784
	],
	"./promo-seasonal": [
		8408,
		7,
		408
	],
	"./promo-seasonal.js": [
		8408,
		7,
		408
	],
	"./scroll-to-section": [
		1904,
		7,
		904
	],
	"./scroll-to-section.js": [
		1904,
		7,
		904
	],
	"./scrolling-ticker": [
		5700,
		9,
		104,
		540
	],
	"./scrolling-ticker.js": [
		5700,
		9,
		104,
		540
	],
	"./team-carousel": [
		2860,
		9,
		104,
		860
	],
	"./team-carousel.js": [
		2860,
		9,
		104,
		860
	],
	"./testimonials": [
		1144,
		9,
		104,
		144
	],
	"./testimonials.js": [
		1144,
		9,
		104,
		144
	],
	"./video-section": [
		896,
		7,
		896
	],
	"./video-section.js": [
		896,
		7,
		896
	],
	"./what-vps-calc": [
		4483,
		9,
		104,
		483
	],
	"./what-vps-calc.js": [
		4483,
		9,
		104,
		483
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8648;
module.exports = webpackAsyncContext;